import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Message} from 'epic-diesel-common';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';

export default class TwoFactorSection extends Component {
    static propTypes = {
        messages: PropTypes.object,
        getMessage: PropTypes.func,
        tfaEnabled: PropTypes.bool,
        styles: PropTypes.object,
        locale: PropTypes.string
    };

    render() {
        const {styles, messages, getMessage, tfaEnabled, locale = 'en-US'} = this.props;
        const subtitleText = getMessage(messages, 'epic.affiliate.presignup.mfa.subtitle', [
            locale
        ]);
        const tfaStatusCode = `epic.affiliate.presignup.mfa.${tfaEnabled ? 'enabled' : 'disabled'}`;

        return (
            <>
                <h2>
                    <Message code="epic.affiliate.presignup.mfa.header" />
                    {' *'}
                </h2>
                <p>
                    <Message code="epic.affiliate.presignup.mfa.title.v2" />{' '}
                    <small
                        className={styles.anchor}
                        dangerouslySetInnerHTML={{__html: subtitleText}}
                    />
                </p>
                <CheckBox
                    name="enabledMfa"
                    validations="checked"
                    validationError={getMessage(
                        messages,
                        'errors.com.epicgames.validation.required_field.v2'
                    )}
                    value={tfaEnabled}>
                    <Message code={tfaStatusCode} />
                </CheckBox>
            </>
        );
    }
}
